'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _sideBar = require('../../constants/sideBar');

var _IPLocationDAO = require('../../data/IPLocationDAO');

var _testimonialSidebarByCountry = require('../../experiments/experiments/testimonialSidebarByCountry');

var _testimonialSidebarByCountry2 = _interopRequireDefault(_testimonialSidebarByCountry);

var _isApp = require('../../utils/isApp');

var _localImages = require('../../utils/localImages');

var _localImages2 = _interopRequireDefault(_localImages);

var _CustomSidebar = require('./custom/CustomSidebar');

var _CustomSidebar2 = _interopRequireDefault(_CustomSidebar);

var _getCustomSidebarOption2 = require('./custom/getCustomSidebarOption');

var _getCustomSidebarOption3 = _interopRequireDefault(_getCustomSidebarOption2);

var _DefaultSidebar = require('./default/DefaultSidebar');

var _DefaultSidebar2 = _interopRequireDefault(_DefaultSidebar);

var _DynamicSidebar = require('./dynamic/DynamicSidebar');

var _DynamicSidebar2 = _interopRequireDefault(_DynamicSidebar);

var _Sidebar = require('./Sidebar.styles');

var _sidebarByCountry = require('./testimonial/sidebarByCountry');

var _TestimonialSidebar = require('./testimonial/TestimonialSidebar');

var _TestimonialSidebar2 = _interopRequireDefault(_TestimonialSidebar);

var _hubspot = require('hubspot.SafeStorage');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _AppConfigContainer = require('../../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Experiment ACQ065

var ACQ065_COUNTRY_CODE_OVERRIDE = 'ACQ065_COUNTRY_CODE_OVERRIDE';

var Sidebar = exports.Sidebar = function (_React$Component) {
  _inherits(Sidebar, _React$Component);

  function Sidebar(props, context) {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props, context));

    _this.state = {
      loading: true,
      iplocation: null,
      shouldRenderTestimonial: false
    };
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchTestimonialExperiment();
    }
  }, {
    key: 'fetchTestimonialExperiment',
    value: function fetchTestimonialExperiment() {
      var _this2 = this;

      // We should render the testimonial only when we don't have a custom sidebar (opt_sidebar) defined.
      if (this.isCustomParamSidebar()) {
        this.disableLoadingState();
        return;
      }

      if (_hubspot2.default.getItem(ACQ065_COUNTRY_CODE_OVERRIDE)) {
        this.disableLoadingState();
        this.setIPLocation({
          countryCode: _hubspot2.default.getItem(ACQ065_COUNTRY_CODE_OVERRIDE)
        });
        return;
      }

      (0, _testimonialSidebarByCountry2.default)().then(function (parameter) {
        if (parameter.value === _testimonialSidebarByCountry.EXPERIMENT_PARAMETER_VERSION_VARIANT) {
          (0, _IPLocationDAO.getCountry)().then(function (iplocation) {
            _this2.disableLoadingState();
            _this2.setIPLocation(iplocation);
          }).catch(function () {
            // If we couldn't get the country information we can just disable the loading
            _this2.disableLoadingState();
          });
        } else {
          // If the experiment is under control just disable the loading
          _this2.disableLoadingState();
        }
      });
    }
  }, {
    key: 'setIPLocation',
    value: function setIPLocation(iplocation) {
      if (iplocation) {
        var shouldRenderTestimonial = _sidebarByCountry.sidebarByCountry.has(iplocation.countryCode);

        this.setState({
          shouldRenderTestimonial: shouldRenderTestimonial,
          iplocation: iplocation
        });
      }
    }
  }, {
    key: 'disableLoadingState',
    value: function disableLoadingState() {
      this.setState({
        loading: false
      });
    }
  }, {
    key: 'getCustomSidebarConfigKey',
    value: function getCustomSidebarConfigKey() {
      var app = (0, _isApp.appName)();
      if (this.isCustomAppSidebar(app)) {
        return app;
      }

      var path = _AppConfigContainer2.default.get('baseHistoryPath');
      if (this.isCustomAppSidebar(path)) {
        return path;
      }

      return null;
    }
  }, {
    key: 'getCustomSidebarOption',
    value: function getCustomSidebarOption() {
      return (0, _getCustomSidebarOption3.default)() || this.getCustomSidebarConfigKey() || null;
    }
  }, {
    key: 'isCustomParamSidebar',
    value: function isCustomParamSidebar() {
      return (0, _getCustomSidebarOption3.default)() !== null;
    }
  }, {
    key: 'isCustomAppSidebar',
    value: function isCustomAppSidebar(app) {
      return !!_sideBar.sidebarMapping[app];
    }
  }, {
    key: 'isRenderingCustomLogo',
    value: function isRenderingCustomLogo(app) {
      return this.isCustomAppSidebar(app) && _sideBar.sidebarMapping[app].customLogo;
    }
  }, {
    key: 'renderLogo',
    value: function renderLogo(app) {
      var customLogo = this.isRenderingCustomLogo(app);

      return _react2.default.createElement(_Sidebar.SidebarLogo, {
        style: customLogo ? _sideBar.sidebarMapping[app].logoStyles : {},
        src: customLogo ? _localImages2.default.get(_sideBar.sidebarMapping[app].customLogo) : _localImages2.default.get('hubspotLogoWhite')
      });
    }
  }, {
    key: 'renderSidebarContent',
    value: function renderSidebarContent() {
      var dynamicSidebar = this.props.dynamicSidebar;

      var customSidebarType = this.getCustomSidebarOption();

      if (dynamicSidebar) {
        return this.renderDynamicSidebar(dynamicSidebar);
      }

      if (this.state.shouldRenderTestimonial) {
        return this.renderTestimonialSidebar();
      }

      if (customSidebarType) {
        return this.renderCustomSidebar(customSidebarType);
      }

      return this.renderDefaultSidebar();
    }
  }, {
    key: 'renderDynamicSidebar',
    value: function renderDynamicSidebar(dynamicSidebar) {
      return _react2.default.createElement(_DynamicSidebar2.default, dynamicSidebar.toJS());
    }
  }, {
    key: 'renderTestimonialSidebar',
    value: function renderTestimonialSidebar() {
      var countryCode = this.state.iplocation.countryCode;
      return _react2.default.createElement(_TestimonialSidebar2.default, _sidebarByCountry.sidebarByCountry.get(countryCode).toJS());
    }
  }, {
    key: 'renderDefaultSidebar',
    value: function renderDefaultSidebar() {
      return _react2.default.createElement(_DefaultSidebar2.default, null);
    }
  }, {
    key: 'renderCustomSidebar',
    value: function renderCustomSidebar(sidebarType) {
      return _react2.default.createElement(_CustomSidebar2.default, { sidebarType: sidebarType });
    }
  }, {
    key: 'render',
    value: function render() {
      var app = (0, _isApp.appName)();
      var customSidebarConfigKey = this.getCustomSidebarConfigKey();

      return _react2.default.createElement(
        _Sidebar.SidebarContainer,
        { appName: app },
        this.renderLogo(customSidebarConfigKey),
        this.state.loading ? _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) : _react2.default.createElement(
          _Sidebar.SidebarContent,
          null,
          this.renderSidebarContent()
        )
      );
    }
  }]);

  return Sidebar;
}(_react2.default.Component);

Sidebar.propTypes = {
  dynamicSidebar: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    dynamicSidebar: state.dynamicSidebar
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Sidebar);